import { FC } from "react";
import { Box, Collapse } from "@mui/material";
import { useToggle } from "rooks";
import { SavingsPlanDrawerChartHeader } from "./SavingsPlanDrawerChartHeader";
import { CommitmentsDrawerChart } from "../common/CommitmentsDrawerChart";
import { CommitmentsDrawerCollapseHeader } from "../common/CommitmentsDrawerCollapseHeader";
import { CommitmentsDrawerDataGrid } from "../common/data-grid/CommitmentsDrawerDataGrid";

export const SavingsPlanDrawerCollapsableSection: FC = () => {
  const [collapsed, toggleCollapsed] = useToggle();

  return (
    <Box bgcolor="grey.50" py={2} px={1}>
      <CommitmentsDrawerCollapseHeader
        title="Utilization"
        collapsed={collapsed}
        onClick={toggleCollapsed}
      />

      <Collapse in={!collapsed}>
        <Box py={2} px={1}>
          <CommitmentsDrawerChart ChartHeader={SavingsPlanDrawerChartHeader} />

          <CommitmentsDrawerDataGrid viewTab="savingsPlans" />
        </Box>
      </Collapse>
    </Box>
  );
};
